import { Text, View, StyleSheet } from '@react-pdf/renderer';
import { PersonalState } from '../interfaces/store';
import {PersonIcon} from '../assets/components/person'
import { PhoneIcon } from '../assets/components/phone';
import { EmailIcon } from '../assets/components/email';
import { HouseIcon } from '../assets/components/house';
import { BirthDayIcon } from '../assets/components/birthday';
import { HartIcon } from '../assets/components/hart';
import { NationalityIcon } from '../assets/components/nationality';
import { CarIcon } from '../assets/components/car';
import { LocationIcon } from '../assets/components/location';

type PersonalPdfProps = {
    personaData: PersonalState;
    color: string
};

const styles = StyleSheet.create({
    // document: { backgroundColor: 'white', height: '100%' },
    page: {
      padding: 0,
      fontSize: 12,
    },
    row: {
      flexDirection: 'row',
      width: '100%',
      height: '100%',
    },
    sidePanel: {
      width: '40%',
      backgroundColor: 'red',
      padding: '6',
      height: '100%',
    },
    avatar: {
      width: '125',
      height: '125',
      borderRadius: '25',
      margin: 'auto',
      border: '',
    },
    avatarContainer: {
      padding: '6',
      height: '190',
    },
    headingBorderline: {
      textAlign: 'center',
      borderBottom: '1 solid whitesmoke',
      fontSize: '21',
      paddingTop: '4',
      paddingBottom: '4',
      fontWeight: '500',
    },
    headingLabel: {
      fontSize: '21',
      fontWeight: '500',
      paddingTop: '9',
      paddingBottom: '9',
    },
    flex: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
    },
    text: {
      padding: '6',
      width: '90%',
    }
  });

export const PersonaliaPdf: React.FC<PersonalPdfProps> = ({ personaData, color }: PersonalPdfProps) => {
    const t: any = { ...personaData }
    if (t) {
      delete t.avatar
      delete t.description
    }
    console.log(t)
    return <View>
        {Object.keys(t).length === 0 ? (
            <Text>No personal data available.</Text>
          ) : (
            Object.entries(t).map(([key, value]) => {
              if (
                value === null ||
                typeof value === 'object' ||
                typeof value === 'undefined'
              ) {
                return null;
              }

              return (
                <View key={key}>
                  <View style={styles.flex} debug={false}>
                    {key === 'name' && <PersonIcon color={color} />}
                    {key === 'email' && <EmailIcon color={color} />}
                    {key === 'phone' && <PhoneIcon color={color} />}
                    {key === 'street' && <HouseIcon color={color} />}
                    {key === 'birthday' && <BirthDayIcon color={color} />}
                    {key === 'maritalStatus' && <HartIcon color={color} />}
                    {key === 'nationality' && <NationalityIcon color={color} />}
                    {key === 'birthplace' && <LocationIcon color={color} />}
                    {key === 'license' && <CarIcon color={color} />}

                    <Text style={styles.text} debug={false}>
                      {String(value)}
                    </Text>
                  </View>
                </View>
              );
            })
          )}             
        </View>
}